import { graphql } from 'react-relay';

export const ActivityLogsQuery = graphql`
    query ActivityLogsQuery($id: String!, $count: Int, $page: Int, $order_by: [String]) {
        activityLogs(id: $id, page: $page, first: $count, order_by: $order_by) {
            structure {
                field
                type
                display
                nest {
                    field
                    type
                    display
                }
            }
            pageInfo {
                count
            }
            edges {
                node {
                    id
                    event
                    description
                    subject_type
                    subject_id
                    causer_type
                    causer_id
                    causer {
                        id
                        name
                        first_name
                        last_name
                    }
                    properties
                    created_at
                    updated_at
                }
            }
        }
    }
`;
